import { render } from "./CarParts.vue?vue&type=template&id=96ea65b2"
import script from "./CarParts.vue?vue&type=script&lang=js"
export * from "./CarParts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__